export default __webpack_public_path__ + "static/media/file.1f6ea9dc.png";